import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "gender",
    standalone: false
})
export class GenderPipe implements PipeTransform {
    public transform(value: "M" | "F" | "UN"): string {
        switch (value) {
            case "M":
                return "Male";
            case "F":
                return "Female";
            case "UN":
                return "Undifferentiated";
            default:
                return null;
        }
    }
}
